import axios from "../../components/shared/axios"
import { actions } from "../pages"
import { savePage } from "./save"

const saveForPublishing = async (state, dispatch) => {
  await savePage(state, dispatch, false)
  dispatch({ type: actions.SET_PUBLISHING, payload: 'generating' })
}

const publishPage = async (state, dispatch) => {
  const response = await axios.put(state.publishUrl)
  dispatch({ type: actions.SET_PAGE, payload: response.data.page.data })
  dispatch({ type: actions.SET_PUBLISHING, payload: 'published' })
}

const unpublishPage = async (state, dispatch) => {
  const response = await axios.put(state.unpublishUrl)
  dispatch({ type: actions.SET_PAGE, payload: response.data.page.data })
  dispatch({ type: actions.SET_UNPUBLISHING, payload: false })
}

export { saveForPublishing, publishPage, unpublishPage }
